<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div ref="chartContainer" style="width: 100%; height: 600px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'

export default {
  name: 'UserStat',
  props: {
    rate: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '人数'
    },
    k: {
      type: String,
      default: 'spin'
    }
  },
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: this.title
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: []
      }
    },
    refresh(data, rangeTitle) {
      this.initChart()
      const time = []
      const cdata = []
      if (data.length <= 0) {
        this.option.series = []
        this.chart.setOption(this.option, true)
        return
      }
      for (const i in data) {
        const val = data[i]
        time.push(dateStrTodate(val.date))
        for (let i = 1; i <= 9; i++) {
          if (cdata[i] === undefined) {
            cdata[i] = []
          }
          let key = 'spin' + i
          if (this.k === 'rate') {
            key = 'spin' + i + 'Rate'
          }
          if (val[key] !== undefined) {
            cdata[i].push(val[key])
          }
        }
      }
      for (const i in cdata) {
        const val = cdata[i]
        const temp = {
          name: rangeTitle[i - 1],
          data: val,
          type: 'line',
          smooth: true,
          label: {
            show: true,
            position: 'top', // 标签显示在折线图顶部
            formatter: '{c}' // 显示数值
          }
        }
        this.option.series.push(temp)
      }
      this.option.legend.data = rangeTitle
      this.option.xAxis.data = time
      this.chart.setOption(this.option, true)
    }
  }

}
</script>

<style scoped>

</style>
